/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow-restricted-names */
import { api } from './api';

export const commentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createComment: builder.mutation({
      query: ({ threadId, comment }) => ({
        url: `threads/${threadId}/comments`,
        method: 'POST',
        body: { content: comment },
      }),
      transformResponse: (response) => response.data.comment,
      invalidatesTags: (result, error, arg) => [
        { type: 'Thread', id: arg.id },
        'Leaderboard',
      ],
    }),

    upvoteComment: builder.mutation({
      query: ({ threadId, commentId, newUpvotesBy }) => ({
        url: `threads/${threadId}/comments/${commentId}/up-vote`,
        method: 'POST',
      }),

      transformResponse: (response) => response.data.vote,
      invalidatesTags: (result, error, arg) => [
        { type: 'Thread', id: arg.id },
        'Leaderboard',
      ],
    }),

    downvoteComment: builder.mutation({
      query: ({ threadId, commentId, newDownvotesBy }) => ({
        url: `threads/${threadId}/comments/${commentId}/down-vote`,
        method: 'POST',
      }),

      transformResponse: (response) => response.data.vote,
      invalidatesTags: (result, error, arg) => [
        { type: 'Thread', id: arg.id },
        'Leaderboard',
      ],
    }),

    neutralizeCommentVote: builder.mutation({
      query: ({ threadId, commentId, newUpvotesBy, newDownvotesBy }) => ({
        url: `threads/${threadId}/comments/${commentId}/neutral-vote`,
        method: 'POST',
      }),

      transformResponse: (response) => response.data.vote,
      invalidatesTags: (result, error, arg) => [
        { type: 'Thread', id: arg.id },
        'Leaderboard',
      ],
    }),
  }),
});

export const {
  useCreateCommentMutation,
  useUpvoteCommentMutation,
  useDownvoteCommentMutation,
  useNeutralizeCommentVoteMutation,
} = commentsApi;
